// productionSelectionSlice.ts
import { createSlice } from '@reduxjs/toolkit';
import { ProductionSelectionState } from '../types';

//~ Keep a reference to this slice's name for cleanup in case of persistReducer usage
export const name = 'productionSelection';

//~ Initialize your state here
const initialState: ProductionSelectionState = {
    selectedProduction: undefined,
};

export const productionSelectionSlice = createSlice({
    name,
    initialState,
    reducers: {
        //~ Define your synchronous reducers here
        clearSelectedProduction: () => {
            return initialState;
        },
        setProduction: (state, action) => {
            state.selectedProduction = action.payload;
        },
    },
    selectors: {
        //~ Define your selectors here

        selectSelectedProduction: (sliceState) => sliceState.selectedProduction,
        selectIsProductionSelected: (sliceState) =>
            !!sliceState.selectedProduction,

        selectSelectedProductionId: (sliceState) =>
            sliceState.selectedProduction?.id,
        selectSelectedProductionName: (sliceState) =>
            sliceState.selectedProduction?.name,
        selectSelectedProductionActiveStatus: (sliceState) =>
            sliceState.selectedProduction?.activeStatus,
        selectSelectedProductionHasAvatar: (sliceState) =>
            sliceState.selectedProduction?.hasAvatar,
        selectSelectedProductionAvatar: (sliceState) =>
            sliceState.selectedProduction?.avatar,
    },
});

//~ Export defined synchronous reducers here
export const { setProduction, clearSelectedProduction } =
    productionSelectionSlice.actions;

//~ Export defined selectors here
export const {
    selectSelectedProduction,
    selectIsProductionSelected,

    selectSelectedProductionActiveStatus,
    selectSelectedProductionAvatar,
    selectSelectedProductionHasAvatar,
    selectSelectedProductionId,
    selectSelectedProductionName,
} = productionSelectionSlice.selectors;

export const productionSelectionReducer = productionSelectionSlice.reducer;
export default productionSelectionReducer;
